export default {
  namespaced: true,
  state: {
    hasUserClosedSlideOut: false,
    isSlideOutVisible: false,
    sidebarCloseTimeout: null
  },

  mutations: {
    CLOSE_SLIDEOUT (state) {
      state.isSlideOutVisible = false
      state.hasUserClosedSlideOut = true
    },

    OPEN_SLIDEOUT (state) {
      state.isSlideOutVisible = true
      state.hasUserClosedSlideOut = false
    },

    SET_SIDEBAR_CLOSE_TIMEOUT (state, timeout) {
      state.sidebarCloseTimeout = timeout
    },

    CLEAR_SIDEBAR_CLOSE_TIMEOUT (state) {
      clearTimeout(state.sidebarCloseTimeout)
    }
  },

  getters: {
    activeSidebar (state, getters, rootState, rootGetters) {
      const routeName = rootState.route.name
      const pathway = rootState.route.params.pathway

      if (routeName === 'page' && rootGetters.activePage) {
        return {
          description: rootGetters.activePage.description['en'],
          filterType: '',
          heading: rootGetters.activePage.heading['en'],
          markerGuide: false,
          minimap: rootGetters.activePage.minimapImage,
          qrMessage: rootGetters.activePage.qrMessage,
          qrUrl: rootGetters.activePage.qrUrl,
          virtualTourUrl: rootGetters.activePage.virtualTourUrl,
          virtualTourButtonLabel: rootGetters.activePage.virtualTourButtonLabel,
          issuuEmbedUrl: rootGetters.activePage.issuuEmbedUrl,
          activeBackLink: getters.activeBackLink,
          iframes: rootGetters.activePage.iframes,
        }
      }

      if (['live', 'living-option'].includes(routeName) && rootGetters.config) {        
        return {
          description: rootGetters.config.liveHereDescription['en'],
          filterType: pathway,
          heading: rootGetters.config.liveHereHeading['en'],
          markerGuide: false,
          minimap: rootGetters.config.liveHereSidebarMinimap,
          qrMessage: '',
          qrUrl: '',
          isFilterHidden: rootGetters['property/activeLivingOption'] ? rootGetters['property/activeLivingOption'].isFilterHidden : false,
          activeBackLink: getters.activeBackLink
        }
      }

      if (['living-entry'].includes(routeName) && rootGetters.config) {        
        return {
          description: rootGetters.config.liveHereDescription['en'],
          filterType: '',
          heading: rootGetters.config.liveHereHeading['en'],
          markerGuide: false,
          minimap: rootGetters.config.liveHereSidebarMinimap,
          qrMessage: '',
          qrUrl: '',
          activeBackLink: getters.activeBackLink
        }
      }

      if (['subsection', 'property'].includes(routeName) && rootGetters['property/activeSubsection']) {        
        return {
          description: rootGetters['property/activeSubsection'].description,
          filterType: pathway,
          heading: rootGetters['property/activeSubsection'].label,
          markerGuide: rootGetters['property/activeSubsection'].properties.length ? true : false,
          minimap: rootGetters['property/activeSubsection'].minimapImage,
          sidebarMapImage: rootGetters['property/activeSubsection'].sidebarMapImage,
          qrMessage: '',
          qrUrl: '',
          isFilterHidden: rootGetters['property/activeSubsection'].isFilterHidden,
          activeBackLink: getters.activeBackLink
        }
      }

      if (['masterplan-subsection', 'masterplan-property'].includes(routeName) && rootGetters['masterplan/activeSubsection']) {        
        return {
          description: rootGetters['masterplan/activeSubsection'].description,
          filterType: pathway,
          heading: rootGetters['masterplan/activeSubsection'].label,
          markerGuide: rootGetters['masterplan/activeSubsection'].properties.length ? true : false,
          minimap: rootGetters['masterplan/activeSubsection'].minimapImage,
          sidebarMapImage: rootGetters['masterplan/activeSubsection'].sidebarMapImage,
          qrMessage: '',
          qrUrl: '',
          isFilterHidden: rootGetters['masterplan/activeSubsection'].isFilterHidden,
          iframes: rootGetters['masterplan/activeSubsection'].iframes,
          activeBackLink: getters.activeBackLink
        }
      }

      if (['packages', 'package-modal'].includes(routeName) && rootGetters.config) {
        return {
          description: rootGetters.config.liveHerePackagesSidebarDesc['en'],
          filterType: 'package',
          heading: rootGetters.config.liveHerePackagesSidebarHeading['en'],
          markerGuide: false,
          minimap: '',
          qrMessage: '',
          qrUrl: '',
        }
      }

      if (['dwellings', 'dwelling-modal'].includes(routeName) && rootGetters.config) {
        return {
          description: rootGetters.config.liveHerePackagesSidebarDesc['en'],
          filterType: 'dwelling',
          heading: rootGetters.config.liveHerePackagesSidebarHeading['en'],
          markerGuide: false,
          minimap: '',
          qrMessage: '',
          qrUrl: '',
        }
      }

      if (['favourites', 'favourite-modal'].includes(routeName) && rootGetters.config) {
        return {
          description: rootGetters.config.liveHereFavouritesSidebarDesc['en'],
          filterType: '',
          heading: rootGetters.config.liveHereFavouritesSidebarHeading['en'],
          markerGuide: false,
          minimap: '',
          qrMessage: '',
          qrUrl: rootGetters['favourites/qrcode'],
        }
      }

      return {}
    },

    activeBackLink (state, getters, rootState, rootGetters) {
      const activeLivingOption =  rootGetters['property/activeLivingOption']
      const activeSubsection = rootGetters['property/activeSubsection']
      const categoryId = rootState.route.params.categoryId
      const currentRoute = rootState.route.name
      const livingOptionId = rootState.route.params.livingOptionId
      const pathway = rootState.route.params.pathway
      const subsectionId = rootState.route.params.subsectionId

      if (currentRoute === 'living-option') {
        return `/category/${categoryId}/live/${pathway}`
      }

      if (currentRoute === 'property') {
        return `/category/${categoryId}/live/${pathway}/${livingOptionId}/subsection/${subsectionId}${'?activeSubsectionId=' + rootState.route.query.activeSubsectionId}`
      }

      if (currentRoute === 'subsection') {
        if (activeSubsection.parent.type === 'subsection') {
          return `/category/${categoryId}/live/${pathway}/${livingOptionId}/subsection/${activeSubsection.parent.id}${'?activeSubsectionId=' + rootState.route.query.activeSubsectionId}`
        }

        if (activeSubsection.parent.type === 'livingOption') {
          if (activeLivingOption.subsections.length === 1) {
            return `/category/${categoryId}/live/${pathway}`
          } else {
            return `/category/${categoryId}/live/${pathway}/${activeSubsection.parent.id}`
          }
        }
      }

      if (['favourites', 'favourite-modal'].includes(currentRoute)) {
        return rootState.favourites.favouritesBackLink
      }

      return null
    },
    
    isSlideOutVisible (state) {
      return state.isSlideOutVisible
    },

    shouldSlideOutAutoOpen (state) {
      return !state.hasUserClosedSlideOut && !state.isSlideOutVisible
    }
  }
}
